import { redirect } from "react-router-dom";
import { Role, User } from "../../auth/types/interfaces";
import { forbiddenResponse } from "../constants";
import { ROUTES } from "../../app/constants";
export const loader = async (user: User) => {
  {
    if (user.roles.includes(Role.WC_CLAIM_PRODUCT_GROUP)) {
      return redirect(ROUTES.LANDING_PAGE);
    }
    if (user.roles.includes(Role.CARGO_CLAIM_USER)) {
      return redirect(ROUTES.CARGO_CLAIM_INTAKE_FORM);
    }
    if (user.roles.includes(Role.IPL_CLAIM_USER)) {
      return redirect(ROUTES.IPL_CLAIM_INTAKE_FORM);
    }
    if (
      user.roles.includes(Role.WC_CLAIM_USER) ||
      user.roles.includes(Role.WC_CLAIM_USER_LIMITED) ||
      user.roles.includes(Role.WC_CLAIM_CANADA_USER)
    ) {
      return redirect(ROUTES.WC_CLAIM_INTAKE_FORM);
    }
    // If user has no roles then deny access to the app
    return forbiddenResponse();
  }
};
